export const userName = (firstName, lastName) => {
	const name = `${firstName} ${lastName}`;

	if (name.length > 10) {
		return name.slice(0, 10) + '...';
	}

	return name;
};

export const userLink = user => {
	if (user.username) {
		return `/user/${user.username}`;
	}

	return `/user/${user._id}`;
};

export const userAvatar = user => {
	if (user.lastName) {
		return `${user.firstName.slice(0, 1).toUpperCase()}${user.lastName.slice(0, 1).toUpperCase()}`;
	}

	return user.firstName.slice(0, 1).toUpperCase();
};
